import { graphql } from 'react-relay';

export default graphql`
    query headerRootQuery(
        $hasUserId: Boolean!
        $previewKey: String = ""
        $showMarketingMessages: Boolean!
        $fetchMarketingMessagesTransactions: Boolean = false
        $userId: String!
        $userIds: [String]!
    ) {
        viewer {
            ...Header_viewer
        }
        serverViewer: viewer {
            navigation(rootId: $previewKey) {
                ...Header_navigation
            }
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    previewKey: '',
    showMarketingMessages: false,
    userId: '',
    userIds: [],
};
